import React, { useRef, useState } from 'react';
import {
  Button,
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  InputGridGroup,
  Paper,
  QuantaInput,
  QuantaSelect,
  useQuantaFormikContext,
  Text,
  Grid,
  GridItem,
  QuantaTextArea,
  NotificationList,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import {
  DOCUMENT_STATIC_DATA,
  GET_DEFAULT_CLAUSES,
  GET_DEFAULT_CONDITIONS,
  GET_DEFAULT_EXCLUSIONS,
  GET_DEFAULT_WARRANTIES,
  GET_FIRE_POLICY_VAR_DETAILS,
  GET_FIRE_QUOTE_DOCS,
  GET_FIRE_UPLOAD_POLICY_VAR_DETAILS,
} from '../../queries';
// import { Error, Loading } from '../../../../../../lib/layout';
import { Error, Loading } from 'quanta-flows/modules/layout';
import CustomerSummary from '../common/customer-summary';
import LocationCoverageDetails from '../common/location-coverage-details';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronCircleRight,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
// import { updateFireQuote } from '../../_graphql/state';
import { updateFireQuote } from 'quanta-flows/modules/quote/fire/state';
import ModalSubmitQuote from './modal-submit-quote';
import ModalSaveQuote from './modal-save-quote';

export default function AdditionalDetails({
  goToStep,
  productCode,
  productName,
  lobCode,
  role,
  additionalDetailsFormRef,
  setParentAlerts,
  setButtonLabelCustomerTab,
}) {
  const {
    loading: loadingUploadDocsVar,
    error: errorUploadDocsVar,
    data: dataUploadDocsVar,
  } = useQuery(GET_FIRE_UPLOAD_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingFireQuoteVar,
    error: errorFireQuoteVar,
    data: dataFireQuoteVar,
  } = useQuery(GET_FIRE_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingDocList,
    error: errorDocList,
    data: dataDocList,
  } = useQuery(GET_FIRE_QUOTE_DOCS, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingDefaultWarranties,
    error: errorDefaultWarranties,
    data: dataDefaultWarranties,
  } = useQuery(GET_DEFAULT_WARRANTIES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '4',
      },
    },
  });

  const {
    loading: loadingDocumentExtensions,
    error: errorDocumentExtensions,
    data: dataDocumentExtensions,
  } = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingDefaultClauses,
    error: errorDefaultClauses,
    data: dataDefaultClauses,
  } = useQuery(GET_DEFAULT_CLAUSES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '1',
      },
    },
  });

  const {
    loading: loadingDefaultConditions,
    error: errorDefaultConditions,
    data: dataDefaultConditions,
  } = useQuery(GET_DEFAULT_CONDITIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '2',
      },
    },
  });

  const {
    loading: loadingDefaultExclusions,
    error: errorDefaultExclusions,
    data: dataDefaultExclusions,
  } = useQuery(GET_DEFAULT_EXCLUSIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '3',
      },
    },
  });

  let repeatForMobile = 1;
  let repeatForDesktop = 2;
  let repeatForMobileAdditionalDetails = 1;
  let repeatForDesktopAdditionalDetails = 3;

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_iPad: 'iPad',
    for_desktop: 'desktop',
  });

  const repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  const repeatAdditionalDetails = useResponsiveParams({
    for_mobile: repeatForMobileAdditionalDetails,
    for_desktop: repeatForDesktopAdditionalDetails,
  });

  if (
    loadingUploadDocsVar ||
    loadingFireQuoteVar ||
    loadingDocList ||
    loadingDefaultWarranties ||
    loadingDefaultClauses ||
    loadingDefaultConditions ||
    loadingDefaultExclusions ||
    loadingDocumentExtensions
  ) {
    return <Loading />;
  }
  if (
    errorUploadDocsVar ||
    errorFireQuoteVar ||
    errorDocList ||
    errorDefaultClauses ||
    errorDefaultConditions ||
    errorDefaultWarranties ||
    errorDefaultExclusions ||
    errorDocumentExtensions
  ) {
    return (
      <Error
        error={
          errorUploadDocsVar ||
          errorFireQuoteVar ||
          errorDocList ||
          errorDefaultClauses ||
          errorDefaultConditions ||
          errorDefaultWarranties ||
          errorDefaultExclusions ||
          errorDocumentExtensions
        }
      />
    );
  }
  const { documentDetails: documentDetailsVar } =
    dataUploadDocsVar?.fireQuoteUploadDocs?.documentDetails;
  const { fireQuote, selectedIntermediary } = dataFireQuoteVar;
  const {
    documentListFire,
    documentExtensions,
    docFileSizeLimit,
    docDescCharacterLimit,
  } = dataDocList;

  const { getDefaultWarranties } = dataDefaultWarranties;
  const { getDefaultClauses } = dataDefaultClauses;
  const { getDefaultConditions } = dataDefaultConditions;
  const { getDefaultExclusions } = dataDefaultExclusions;

  const isQuoteReadOnly =
    fireQuote?.status?.toString()?.toLowerCase() === 'quote saved' ||
    fireQuote?.status?.toString()?.toLowerCase() ===
      'pending uw approval' ||
    fireQuote?.status?.toString()?.toLowerCase() ===
      'underwriter rejected' ||
    fireQuote?.status?.toString()?.toLowerCase() ===
      'underwriter approved' ||
    fireQuote?.status?.toString()?.toLowerCase() ===
      'converted to proposal';

  const initialValues = {
    userDefinedClauses:
      fireQuote?.tabDetails?.additionalTabDetails?.clauses
        ?.userDefinedClauses &&
      fireQuote?.tabDetails?.additionalTabDetails?.clauses
        ?.userDefinedClauses?.length > 0
        ? fireQuote?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.map(
            (clause) => {
              return {
                clause,
              };
            },
          )
        : [
            {
              clause: '',
            },
          ],
    userDefinedConditions:
      fireQuote?.tabDetails?.additionalTabDetails?.conditions
        ?.userDefinedConditions &&
      fireQuote?.tabDetails?.additionalTabDetails?.conditions
        ?.userDefinedConditions?.length > 0
        ? fireQuote?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.map(
            (condition) => {
              return {
                condition,
              };
            },
          )
        : [
            {
              condition: '',
            },
          ],
    userDefinedWarranties:
      fireQuote?.tabDetails?.additionalTabDetails?.warranties
        ?.userDefinedWarranties &&
      fireQuote?.tabDetails?.additionalTabDetails?.warranties
        ?.userDefinedWarranties?.length > 0
        ? fireQuote?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.map(
            (warranty) => {
              return {
                warranty,
              };
            },
          )
        : [
            {
              warranty: '',
            },
          ],
    userDefinedExclusions:
      fireQuote?.tabDetails?.additionalTabDetails?.exclusions
        ?.userDefinedExclusions &&
      fireQuote?.tabDetails?.additionalTabDetails?.exclusions
        ?.userDefinedExclusions?.length > 0
        ? fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.map(
            (exclusion) => {
              return {
                exclusion,
              };
            },
          )
        : [
            {
              exclusion: '',
            },
          ],
    documentDetails:
      documentDetailsVar && documentDetailsVar?.length > 0
        ? documentDetailsVar
        : [
            {
              documentDescription: '',
              documentName: '',
              documentNameValue: '',
              documentFileName: '',
              documentFileNameWithExtension: '',
              documentExtension: '',
              documentSize: null,
              documentSizeinKB: '',
              dragging: false,
              dragCounter: 0,
              documentBase64String: '',
            },
          ],
    underwriterComment: fireQuote?.tabDetails?.additionalTabDetails
      ?.underwriterComment
      ? fireQuote?.tabDetails?.additionalTabDetails
          ?.underwriterComment
      : '',
  };
  const onSubmit = (values) => {
    return true;
  };
  const validate = (values) => {
    const errors = {};
    let errorCount = 0;
    errors.documentDetails = values?.documentDetails?.map((_) => {
      return {};
    });

    for (let i = 0; i < values?.documentDetails?.length; i++) {
      if (
        values?.documentDetails[i]?.documentNameValue
          ?.toString()
          ?.toLowerCase()
          ?.trim() === 'others' &&
        !values?.documentDetails[i]?.documentDescription
      ) {
        errors.documentDetails[i].documentDescription = '* Required';
        errorCount += 1;
      }
      if (
        values?.documentDetails[i]?.documentDescription &&
        !values?.documentDetails[i]?.documentDescription?.match(
          /^[a-zA-Z ]*$/,
        )
      ) {
        errors.documentDetails[
          i
        ].documentDescription = `* Can only contain alphabets`;
        errorCount += 1;
      }
      if (
        values?.documentDetails[i]?.documentDescription &&
        values?.documentDetails[i]?.documentDescription?.length >
          parseInt(docDescCharacterLimit?.code)
      ) {
        errors.documentDetails[
          i
        ].documentDescription = `* Can be of maximum ${docDescCharacterLimit?.value} characters`;
        errorCount += 1;
      }
      if (
        (values?.documentDetails[i]?.documentName ||
          values?.documentDetails[i]?.documentDescription) &&
        !values?.documentDetails[i]?.documentFileName
      ) {
        errors.documentDetails[
          i
        ].documentFileName = `* Input file not provided`;
        errorCount += 1;
      }
      if (
        (values?.documentDetails[i]?.documentName ||
          values?.documentDetails[i]?.documentDescription) &&
        !values?.documentDetails[i]?.documentSize
      ) {
        errors.documentDetails[
          i
        ].documentSize = `* File size details is unknown`;
        errorCount += 1;
      }
    }

    // if (
    //   fireQuote?.status?.toString()?.toLowerCase() ===
    //     'pending uw approval' &&
    //   role?.toString().toLowerCase() === 'underwriter' &&
    //   !values?.underwriterComment
    // ) {
    //   errors.underwriterComment = '* Required';
    //   errorCount += 1;
    // }
    if (errorCount > 0) {
      return errors;
    }
    return {};
  };

  const AdditionalDetailsForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [submitQuoteModalDisplay, setSubmitQuoteModalDisplay] =
      useState(false);
    const [modalSaveQuoteDisplay, setModalSaveQuoteDisplay] =
      useState(false);
    const uploadDocRef = useRef([]);
    const [alerts, setAlerts] = useState([]);
    const uploadDocumentsData = [
      {
        title: (
          <Text severity={'info'} className={'text-lg'}>
            Upload Documents
          </Text>
        ),
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => {
              return (
                <Text
                  severity={'info'}
                  className={'flex space-x-2 items-center my-2'}
                >
                  <Text>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Text>
                  <Text>
                    We support{' '}
                    <Text className={'font-semibold'}>
                      {dataDocumentExtensions?.documentExtensions
                        ?.map((extension) => extension?.value)
                        ?.join(', ')}
                    </Text>{' '}
                    formats for your documents to upload.You can
                    upload upto{' '}
                    <Text className={'font-semibold'}>
                      {
                        dataDocumentExtensions?.docFileSizeLimit
                          ?.value
                      }
                    </Text>{' '}
                    maximum size for a single file{' '}
                  </Text>
                </Text>
              );
            },
          },
          ...(values?.documentDetails &&
          values?.documentDetails?.length > 0
            ? values?.documentDetails?.map((_, idx) => {
                return {
                  type: 'render',
                  colSpan: repeat,
                  component: () => {
                    return (
                      <Paper
                        className={`bg-neutral-light shadow-md rounded border border-neutral p-4 flex flex-${
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'col space-y-6'
                            : 'row space-x-6'
                        }`}
                      >
                        <Text
                          className={
                            screenType?.toString()?.toLowerCase() ===
                            'mobile'
                              ? 'w-full'
                              : 'flex flex-col w-1/3'
                          }
                        >
                          <Text>
                            <QuantaSelect
                              name={`documentDetails[${idx}].documentName`}
                              size={'full'}
                              disabled={
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() === 'quote saved' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'pending uw approval' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'underwriter rejected' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'underwriter approved' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'converted to proposal'
                              }
                              label={
                                <Text type={'label'}>
                                  Document Type{' '}
                                  <Text severity={'error'}></Text>
                                </Text>
                              }
                              onDataChange={(val, _) => {
                                setFieldValue(
                                  `documentDetails[${idx}].documentNameValue`,
                                  documentListFire?.find(
                                    (document) =>
                                      document?.code
                                        ?.toString()
                                        ?.toLowerCase() ===
                                      val?.toString()?.toLowerCase(),
                                  )?.value,
                                );
                              }}
                              data={
                                documentListFire &&
                                documentListFire?.length > 0
                                  ? documentListFire?.map(
                                      (document) => {
                                        return {
                                          label: document?.value
                                            ? `${document?.value}`
                                            : '',
                                          value: document?.code
                                            ? `${document?.code}`
                                            : '',
                                        };
                                      },
                                    )
                                  : []
                              }
                            />
                          </Text>
                          <Text>
                            <QuantaInput
                              name={`documentDetails[${idx}].documentDescription`}
                              size={'full'}
                              label={
                                <Text type={'label'}>
                                  Description{' '}
                                  <Text severity={'error'}>
                                    {values?.documentDetails[
                                      idx
                                    ]?.documentNameValue
                                      ?.toString()
                                      ?.toLowerCase()
                                      ?.trim() === 'others'
                                      ? '*'
                                      : ''}
                                  </Text>
                                </Text>
                              }
                              disabled={
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() === 'quote saved' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'pending uw approval' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'underwriter rejected' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'underwriter approved' ||
                                fireQuote?.status
                                  ?.toString()
                                  ?.toLowerCase() ===
                                  'converted to proposal'
                              }
                              placeholder={
                                'Type description if others'
                              }
                              onKeyDown={(evt) => {
                                if (
                                  (evt?.target?.value
                                    ?.toString()
                                    ?.endsWith(' ') &&
                                    evt?.key === ' ') ||
                                  (evt?.target?.value?.toString()
                                    ?.length === 0 &&
                                    evt?.key === ' ')
                                ) {
                                  evt.preventDefault();
                                }
                              }}
                            />
                          </Text>
                        </Text>
                        <span
                          onDragEnter={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            if (
                              values?.documentDetails[idx]
                                ?.documentName
                            ) {
                              setFieldValue(
                                `documentDetails[${idx}].dragCounter`,
                                values?.documentDetails[idx]
                                  ?.dragCounter + 1,
                              );
                              if (
                                evt?.dataTransfer?.items?.length > 0
                              ) {
                                setFieldValue(
                                  `documentDetails[${idx}].dragging`,
                                  true,
                                );
                              }
                            }
                          }}
                          onDragLeave={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            if (
                              values?.documentDetails[idx]
                                ?.documentName
                            ) {
                              if (
                                values?.documentDetails[idx]
                                  ?.dragCounter === 1
                              ) {
                                setFieldValue(
                                  `documentDetails[${idx}].dragging`,
                                  false,
                                );
                              }
                              setFieldValue(
                                `documentDetails[${idx}].dragCounter`,
                                values?.documentDetails[idx]
                                  ?.dragCounter - 1,
                              );
                            }
                          }}
                          onDragOver={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                          }}
                          onDrop={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            if (
                              values?.documentDetails[idx]
                                ?.documentName &&
                              evt?.dataTransfer?.files?.length > 0
                            ) {
                              if (
                                documentExtensions?.find(
                                  (extension) =>
                                    extension?.value
                                      ?.toString()
                                      ?.toLowerCase() ===
                                    evt?.dataTransfer?.files[0]?.name
                                      ?.split('.')
                                      .pop()
                                      ?.toString()
                                      ?.toLowerCase(),
                                )
                              ) {
                                let reader = new FileReader();
                                const file =
                                  evt?.dataTransfer?.files[0];
                                if (
                                  file?.size / 1024 <=
                                  parseFloat(docFileSizeLimit?.code)
                                ) {
                                  setFieldValue(
                                    `documentDetails[${idx}].documentExtension`,
                                    documentExtensions?.find(
                                      (extension) =>
                                        extension?.value
                                          ?.toString()
                                          ?.toLowerCase() ===
                                        file?.name
                                          ?.split('.')
                                          .pop()
                                          ?.toString()
                                          ?.toLowerCase(),
                                    )?.code,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentSize`,
                                    parseFloat(
                                      parseFloat(
                                        file?.size / 1024,
                                      )?.toFixed(2),
                                    ),
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentSizeinKB`,
                                    `${parseFloat(
                                      parseFloat(
                                        file?.size / 1024,
                                      )?.toFixed(2),
                                    )} Kb`,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentFileName`,
                                    file?.name?.split('.')[0],
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].documentFileNameWithExtension`,
                                    file?.name,
                                  );
                                  reader.readAsDataURL(file);
                                  reader.onload = () => {
                                    setFieldValue(
                                      `documentDetails[${idx}].documentBase64String`,
                                      reader.result,
                                    );
                                  };
                                  //evt.dataTransfer.clearData();
                                  setFieldValue(
                                    `documentDetails[${idx}].dragCounter`,
                                    0,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].dragging`,
                                    false,
                                  );
                                  uploadDocRef.current = [
                                    ...uploadDocRef?.current?.filter(
                                      (ref) =>
                                        parseInt(
                                          ref?.id?.toString(),
                                        ) !== idx,
                                    ),
                                  ];
                                } else {
                                  setAlerts([
                                    {
                                      id: Date.now(),
                                      header:
                                        'Error fetching document',
                                      content: (
                                        <Text>
                                          File size is larger than{' '}
                                          {docFileSizeLimit?.value}
                                        </Text>
                                      ),
                                      type: 'error',
                                      timeout: 4000,
                                      disableClose: false,
                                    },
                                  ]);
                                  setFieldValue(
                                    `documentDetails[${idx}].dragCounter`,
                                    0,
                                  );
                                  setFieldValue(
                                    `documentDetails[${idx}].dragging`,
                                    false,
                                  );
                                  uploadDocRef.current = [];
                                }
                              } else {
                                //evt.dataTransfer.clearData();
                                setFieldValue(
                                  `documentDetails[${idx}].dragCounter`,
                                  0,
                                );
                                setFieldValue(
                                  `documentDetails[${idx}].dragging`,
                                  false,
                                );
                                setAlerts([
                                  {
                                    id: Date.now(),
                                    content: (
                                      <Text>
                                        Input file Format is not
                                        supported
                                      </Text>
                                    ),
                                    type: 'error',
                                    disableClose: false,
                                    timeout: 4000,
                                  },
                                  ...alerts,
                                ]);
                                uploadDocRef.current = [
                                  ...uploadDocRef?.current?.filter(
                                    (ref) =>
                                      parseInt(
                                        ref?.id?.toString(),
                                      ) !== idx,
                                  ),
                                ];
                              }
                            }
                          }}
                          className={`w-full my-1 border-2 border-dotted border-secondary justify-center flex flex-col ${
                            screenType?.toString()?.toLowerCase() ===
                            'mobile'
                              ? 'flex-wrap'
                              : ''
                          } p-4`}
                        >
                          <Text
                            className={
                              values?.documentDetails[idx]?.dragging
                                ? 'text-2xl text-neutral-darker flex justify-center'
                                : ''
                            }
                          >
                            {values?.documentDetails[idx]
                              ?.dragging ? (
                              'Drop here'
                            ) : values?.documentDetails[idx]
                                ?.documentFileName ? (
                              <Text className={'flex flex-col'}>
                                <Text className={'flex flex-wrap'}>
                                  <Text>File Name:&nbsp;</Text>
                                  <Text
                                    severity={'info'}
                                    className={
                                      'font-semibold break-normal'
                                    }
                                  >{`${
                                    values?.documentDetails[idx]
                                      ?.documentFileName
                                  }.${
                                    documentExtensions?.find(
                                      (extension) =>
                                        extension?.code
                                          ?.toString()
                                          ?.toLowerCase() ===
                                        values?.documentDetails[
                                          idx
                                        ]?.documentExtension
                                          ?.toString()
                                          ?.toLowerCase(),
                                    )?.value
                                  }`}</Text>
                                </Text>
                                <Text>
                                  File Size:&nbsp;
                                  <Text className={'font-semibold'}>
                                    {`${values?.documentDetails[idx]?.documentSize}`}{' '}
                                    KB
                                  </Text>
                                </Text>
                              </Text>
                            ) : (
                              `${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() !== 'desktop'
                                  ? 'Click the browse button to select a file'
                                  : `Drag and drop your document here to
                                upload. Alternatively you can browse
                                the file by clicking the button`
                              }`
                            )}
                          </Text>
                          {!values?.documentDetails[idx]?.dragging &&
                          !values?.documentDetails[idx]
                            ?.documentFileName ? (
                            <Text
                              className={`flex ${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'flex-col space-y-2'
                                  : 'space-x-2'
                              } justify-end ${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'w-full mt-4'
                                  : ''
                              }`}
                            >
                              {values?.documentDetails?.length >
                                1 && (
                                <Text>
                                  <Button
                                    size={'small'}
                                    flat={true}
                                    className={`h-10 w-24 w-${
                                      screenType
                                        ?.toString()
                                        ?.toLowerCase() === 'mobile'
                                        ? 'full'
                                        : '24'
                                    }`}
                                    onClick={(_) => {
                                      if (
                                        values?.documentDetails
                                          ?.length > 1
                                      ) {
                                        setFieldValue(
                                          `documentDetails`,
                                          [
                                            ...values?.documentDetails?.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values?.documentDetails?.slice(
                                              idx + 1,
                                            ),
                                          ],
                                        );
                                        uploadDocRef.current = [
                                          ...uploadDocRef?.current?.filter(
                                            (ref) =>
                                              parseInt(
                                                ref?.id?.toString(),
                                              ) !== idx,
                                          ),
                                        ];
                                      }
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </Text>
                              )}
                              <Text>
                                <Button
                                  size={'small'}
                                  type={'button'}
                                  flat={false}
                                  className={`h-10 w-24 w-${
                                    screenType
                                      ?.toString()
                                      ?.toLowerCase() === 'mobile'
                                      ? 'full'
                                      : '24'
                                  }`}
                                  disabled={
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'quote saved' ||
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'pending uw approval' ||
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'underwriter rejected' ||
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'underwriter approved' ||
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                      'converted to proposal' ||
                                    !values?.documentDetails[idx]
                                      ?.documentName
                                      ? true
                                      : false
                                  }
                                  onClick={(_) => {
                                    uploadDocRef?.current
                                      ?.find(
                                        (ref) =>
                                          parseInt(
                                            ref?.id?.toString(),
                                          ) === idx,
                                      )
                                      ?.click();
                                  }}
                                >
                                  Browse
                                  <input
                                    key={idx}
                                    id={idx}
                                    ref={(ref) => {
                                      if (
                                        !uploadDocRef?.current?.find(
                                          (r) => r?.id === ref?.id,
                                        ) &&
                                        ref
                                      ) {
                                        uploadDocRef?.current?.push(
                                          ref,
                                        );
                                      }
                                    }}
                                    className="hidden"
                                    type="file"
                                    accept={`${documentExtensions
                                      ?.map(
                                        (extension) =>
                                          `.${extension?.value}`,
                                      )
                                      ?.join(',')}`}
                                    disabled={
                                      !values?.documentDetails[idx]
                                        ?.documentName
                                        ? true
                                        : false
                                    }
                                    onChange={(evt) => {
                                      if (
                                        evt?.target?.files?.length > 0
                                      ) {
                                        let reader = new FileReader();
                                        const file =
                                          evt?.target?.files[0];
                                        if (
                                          file?.size / 1024 <=
                                          parseFloat(
                                            docFileSizeLimit?.code,
                                          )
                                        ) {
                                          setFieldValue(
                                            `documentDetails[${idx}].documentExtension`,
                                            documentExtensions?.find(
                                              (extension) =>
                                                extension?.value
                                                  ?.toString()
                                                  ?.toLowerCase() ===
                                                file?.name
                                                  ?.split('.')
                                                  .pop()
                                                  ?.toString()
                                                  ?.toLowerCase(),
                                            )?.code,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentSize`,
                                            parseFloat(
                                              parseFloat(
                                                file?.size / 1024,
                                              )?.toFixed(2),
                                            ),
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentSizeinKB`,
                                            `${parseFloat(
                                              parseFloat(
                                                file?.size / 1024,
                                              )?.toFixed(2),
                                            )} Kb`,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentFileName`,
                                            file?.name?.split('.')[0],
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentFileNameWithExtension`,
                                            file?.name,
                                          );
                                          reader.readAsDataURL(file);
                                          reader.onload = () => {
                                            setFieldValue(
                                              `documentDetails[${idx}].documentBase64String`,
                                              reader.result,
                                            );
                                          };
                                          setFieldValue(
                                            `documentDetails[${idx}].dragCounter`,
                                            0,
                                          );
                                          uploadDocRef.current = [
                                            ...uploadDocRef?.current?.filter(
                                              (ref) =>
                                                parseInt(
                                                  ref?.id?.toString(),
                                                ) !== idx,
                                            ),
                                          ];
                                        } else {
                                          setAlerts([
                                            {
                                              id: Date.now(),
                                              header:
                                                'Error fetching document',
                                              content: (
                                                <Text>
                                                  File size is larger
                                                  than{' '}
                                                  {
                                                    docFileSizeLimit?.value
                                                  }
                                                </Text>
                                              ),
                                              type: 'error',
                                              timeout: 4000,
                                              disableClose: false,
                                            },
                                          ]);
                                          uploadDocRef.current = [];
                                        }
                                      }
                                      evt.target.value = '';
                                    }}
                                  />
                                </Button>
                              </Text>
                            </Text>
                          ) : values?.documentDetails[idx]
                              ?.documentFileName &&
                            !values?.documentDetails[idx]
                              ?.dragging ? (
                            <Text
                              className={
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'w-full mt-4'
                                  : ''
                              }
                              severity={'action'}
                            >
                              <Text
                                className={`flex ${
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'flex-col space-y-2'
                                    : 'space-x-2'
                                } justify-end ${
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'w-full mt-4'
                                    : ''
                                }`}
                              >
                                {values?.documentDetails?.length >
                                  1 && (
                                  <Text>
                                    <Button
                                      size={'small'}
                                      flat={true}
                                      className={`h-10 w-24 w-${
                                        screenType
                                          ?.toString()
                                          ?.toLowerCase() === 'mobile'
                                          ? 'full'
                                          : '24'
                                      }`}
                                      onClick={(_) => {
                                        if (
                                          values?.documentDetails
                                            ?.length > 1
                                        ) {
                                          setFieldValue(
                                            `documentDetails`,
                                            [
                                              ...values?.documentDetails?.slice(
                                                0,
                                                idx,
                                              ),
                                              ...values?.documentDetails?.slice(
                                                idx + 1,
                                              ),
                                            ],
                                          );
                                          uploadDocRef.current = [
                                            ...uploadDocRef?.current?.filter(
                                              (ref) =>
                                                parseInt(
                                                  ref?.id?.toString(),
                                                ) !== idx,
                                            ),
                                          ];
                                        }
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Text>
                                )}
                                <Text>
                                  <Button
                                    disabled={
                                      fireQuote?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'quote saved' ||
                                      fireQuote?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'pending uw approval' ||
                                      fireQuote?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'underwriter rejected' ||
                                      fireQuote?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'underwriter approved' ||
                                      fireQuote?.status
                                        ?.toString()
                                        ?.toLowerCase() ===
                                        'converted to proposal'
                                    }
                                    size={'small'}
                                    flat={true}
                                    className={`h-10 w-24 w-${
                                      screenType
                                        ?.toString()
                                        ?.toLowerCase() === 'mobile'
                                        ? 'full'
                                        : '24'
                                    }`}
                                    onClick={(_) => {
                                      setFieldValue(
                                        `documentDetails[${idx}].documentFileName`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentFileNameWithExtension`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentExtension`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentSize`,
                                        null,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentSizeinKB`,
                                        '',
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].dragging`,
                                        false,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].dragCounter`,
                                        0,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentBase64String`,
                                        '',
                                      );
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </Text>
                              </Text>
                            </Text>
                          ) : null}
                        </span>
                      </Paper>
                    );
                  },
                };
              })
            : []),
          {
            type: 'render',
            colSpan: repeat,
            component: () => {
              return (
                <Text className={'flex flex-col w-full space-y-2'}>
                  <Text>
                    <Button
                      flat={true}
                      size={'small'}
                      className={
                        screenType?.toString()?.toLowerCase() ===
                        'mobile'
                          ? 'w-full h-10'
                          : 'h-10'
                      }
                      disabled={
                        fireQuote?.status
                          ?.toString()
                          ?.toLowerCase() === 'quote saved' ||
                        fireQuote?.status
                          ?.toString()
                          ?.toLowerCase() === 'pending uw approval' ||
                        fireQuote?.status
                          ?.toString()
                          ?.toLowerCase() ===
                          'underwriter rejected' ||
                        fireQuote?.status
                          ?.toString()
                          ?.toLowerCase() ===
                          'underwriter approved' ||
                        fireQuote?.status
                          ?.toString()
                          ?.toLowerCase() === 'converted to proposal'
                      }
                      onClick={(_) => {
                        setFieldValue('documentDetails', [
                          ...values?.documentDetails,
                          {
                            documentDescription: '',
                            documentName: '',
                            documentNameValue: '',
                            documentFileName: '',
                            documentFileNameWithExtension: '',
                            documentExtension: '',
                            documentSize: null,
                            documentSizeinKB: '',
                            dragging: false,
                            dragCounter: 0,
                            documentBase64String: '',
                          },
                        ]);
                      }}
                    >
                      Add More Document
                    </Button>
                  </Text>
                </Text>
              );
            },
          },
        ],
      },
    ].filter((d) => d);

    const uploadDocumentsDataProps = {
      flow: 'cols',
      repeat: repeat,
      gapX: 4,
      gapY: 4,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    const warrantyData = [
      {
        grid_data: [
          getDefaultWarranties && getDefaultWarranties?.length > 0
            ? {
                type: 'render',
                colSpan: repeatAdditionalDetails,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text className="ml-1 mt-3 font-semibold">
                        Default Warranties
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultWarranties?.map(
                          (warranty, idx) => 
                          warranty?.txtDefault?.toString() === 'Y' ?
                          (
                            <li key={idx}>
                              {warranty?.warrantyShortDescription}
                            </li>
                          ):'',
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          {
            type: 'render',
            colSpan: repeatAdditionalDetails,
            component: () => {
              return (
                <Text type="title" className="font-bold">
                  <Text className="ml-1 mt-3 font-semibold">
                    User Defined Warranties
                  </Text>
                </Text>
              );
            },
          },
          ...(values?.userDefinedWarranties &&
          values?.userDefinedWarranties?.length > 0
            ? values?.userDefinedWarranties?.map((_, idx) => {
                return {
                  type: 'render',
                  colSpan: repeatAdditionalDetails,
                  component: () => {
                    return (
                      <Grid
                        className="mt-2"
                        flow="cols"
                        gap={2}
                        repeat={repeatAdditionalDetails}
                      >
                        <GridItem colSpan={repeatAdditionalDetails}>
                          <Text
                            className={
                              screenType
                                ?.toString()
                                ?.toLowerCase() === 'mobile'
                                ? 'w-full'
                                : 'flex flex-row space-x-5'
                            }
                          >
                            <Text>
                            <QuantaInput
                                rows={3}
                                name={`userDefinedWarranties[${idx}].warranty`}
                                size={'full'}
                                disabled={
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                'pending uw approval'

                                ||
                                fireQuote?.status
                                        ?.toString()
                                  ?.toLowerCase() === 'quote saved'
                                }
                                className={
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'w-full'
                                    : 'w-96'
                                }
                                label={
                                  <Text type={'label'}>
                                    #{idx + 1}{' '}
                                    <Text severity={'error'}></Text>
                                  </Text>
                                }
                              />
                            </Text>
                            {values?.userDefinedWarranties &&
                            values?.userDefinedWarranties?.length >
                              1 ? (
                              <Text
                                severity={'info'}
                                className={'flex items-center'}
                              >
                                {screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile' &&
                                (!fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter')
                                      ) ? (
                                  <Button
                                    flat={true}
                                    size={'small'}
                                    className="w-full"
                                    type={'button'}
                                    onClick={(_) => {
                                      setFieldValue(
                                        `userDefinedWarranties`,
                                        [
                                          ...values.userDefinedWarranties.slice(
                                            0,
                                            idx,
                                          ),
                                          ...values.userDefinedWarranties.slice(
                                            idx + 1,
                                          ),
                                        ],
                                      );
                                    }}
                                  >
                                    Delete
                                  </Button>
                                ) : !fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter') 
                                      ? (
                                  <div className="flex flex-col justify-center items-center">
                                    <Button
                                      flat={true}
                                      className="w-28 h-10"
                                      type={'button'}
                                      size={'small'}
                                      onClick={(_) => {
                                        setFieldValue(
                                          `userDefinedWarranties`,
                                          [
                                            ...values.userDefinedWarranties.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values.userDefinedWarranties.slice(
                                              idx + 1,
                                            ),
                                          ],
                                        );
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                ) : null}
                              </Text>
                            ) : null}
                          </Text>
                        </GridItem>
                      </Grid>
                    );
                  },
                };
              })
            : []),
          !fireQuote?.status ||
          fireQuote?.status?.toString()?.toLowerCase() ===
            'quote draft' ||
          (fireQuote?.status?.toString()?.toLowerCase() ===
            'pending uw approval' &&
            role?.toString()?.toLowerCase() === 'underwriter')
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text>
                      <Button
                        flat={true}
                        size={'small'}
                        type={'button'}
                        disabled={fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'} 
                        className={
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'w-full h-10 mb-4'
                            : 'flex justify-end mr-64 w-28 h-10 mb-4'
                        }
                        onClick={(_) => {
                          setFieldValue('userDefinedWarranties', [
                            ...values?.userDefinedWarranties,
                            {
                              warranty: '',
                            },
                          ]);
                        }}
                      >
                        Add
                      </Button>
                    </Text>
                  );
                },
              }
            : null,
        ],
      },
    ].filter((d) => d);

    const clauseData = [
      {
        grid_data: [
          getDefaultClauses && getDefaultClauses?.length > 0
            ? {
                type: 'render',
                colSpan: repeatAdditionalDetails,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text className="font-semibold ml-1 mt-3">
                        Default Clauses
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultClauses?.map((clause, idx) => 
                        clause?.default?.toString() ==='Y' ?
                        (
                          <li key={idx}>
                            {clause?.clauseDescription}
                          </li>
                        ):'')}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          {
            type: 'render',
            colSpan: repeatAdditionalDetails,
            component: () => {
              return (
                <Text type="title" className="font-bold">
                  <Text className="font-semibold ml-1 mt-3">
                    User Defined Clauses
                  </Text>
                </Text>
              );
            },
          },
          ...(values?.userDefinedClauses &&
          values?.userDefinedClauses?.length > 0
            ? values?.userDefinedClauses?.map((_, idx) => {
                return {
                  type: 'render',
                  colSpan: repeatAdditionalDetails,
                  component: () => {
                    return (
                      <Grid
                        className="mt-2"
                        //flow="cols"
                        //gap={2}
                        repeat={repeatAdditionalDetails}
                      >
                        <GridItem colSpan={repeatAdditionalDetails}>
                          <Text
                            className={
                              screenType
                                ?.toString()
                                ?.toLowerCase() === 'mobile'
                                ? 'w-full'
                                : 'flex flex-row space-x-5'
                            }
                          >
                            <Text>
                            <QuantaInput
                                name={`userDefinedClauses[${idx}].clause`}
                                size='full'
                                disabled={
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                'pending uw approval'

                                ||
                                fireQuote?.status
                                        ?.toString()
                                  ?.toLowerCase() === 'quote saved'
                                }
                                rows={3}
                                className={
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'w-full'
                                    : 'w-96'
                                }
                                label={
                                  <Text type={'label'}>
                                    #{idx + 1}{' '}
                                    <Text severity={'error'}></Text>
                                  </Text>
                                }
                              />
                            </Text>
                            {values?.userDefinedClauses &&
                            values?.userDefinedClauses?.length > 1 ? (
                              <Text
                                severity={'info'}
                                className={'flex items-center'}
                              >
                                {screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile' &&
                                (!fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter')
                                      ) ? (
                                  <Button
                                    flat={true}
                                    className="w-full"
                                    type={'button'}
                                    size={'small'}
                                    onClick={(_) => {
                                      setFieldValue(
                                        `userDefinedClauses`,
                                        [
                                          ...values.userDefinedClauses.slice(
                                            0,
                                            idx,
                                          ),
                                          ...values.userDefinedClauses.slice(
                                            idx + 1,
                                          ),
                                        ],
                                      );
                                    }}
                                  >
                                    Delete
                                  </Button>
                                ) : !fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter') 
                                      ? (
                                  <div className="flex flex-col items-center justify-center">
                                    <Button
                                      flat={true}
                                      className="w-28 h-10"
                                      type={'button'}
                                      size={'small'}
                                      onClick={(_) => {
                                        setFieldValue(
                                          `userDefinedClauses`,
                                          [
                                            ...values.userDefinedClauses.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values.userDefinedClauses.slice(
                                              idx + 1,
                                            ),
                                          ],
                                        );
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                ) : null}
                              </Text>
                            ) : null}
                          </Text>
                        </GridItem>
                      </Grid>
                    );
                  },
                };
              })
            : []),
          !fireQuote?.status ||
          fireQuote?.status?.toString()?.toLowerCase() ===
            'quote draft' ||
          (fireQuote?.status?.toString()?.toLowerCase() ===
            'pending uw approval' &&
            role?.toString()?.toLowerCase() === 'underwriter')
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text>
                      <Button
                        flat={true}
                        size={'small'}
                        type={'button'}
                        disabled={fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'} 
                        className={
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'w-full h-10 mb-4'
                            : 'flex justify-end mr-64 w-28 h-10 mb-4'
                        }
                        onClick={(_) => {
                          setFieldValue('userDefinedClauses', [
                            ...values?.userDefinedClauses,
                            {
                              clause: '',
                            },
                          ]);
                        }}
                      >
                        Add
                      </Button>
                    </Text>
                  );
                },
              }
            : null,
        ]?.filter((d) => d),
      },
    ].filter((d) => d);

    const warrantyDataProps = {
      flow: 'cols',
      repeat: repeatAdditionalDetails,
      gapX: 6,
      gapY: 6,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    const clauseDataProps = {
      flow: 'cols',
      repeat: repeatAdditionalDetails,
      gapX: 6,
      gapY: 6,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    const exclusionData = [
      {
        grid_data: [
          getDefaultExclusions && getDefaultExclusions?.length > 0
            ? {
                type: 'render',
                colSpan: repeatAdditionalDetails,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text className="font-semibold ml-1 mt-3">
                        Default Exclusions
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultExclusions?.map(
                          (exclusion, idx) => 
                          exclusion?.txtDefault?.toString() === 'Y' ?
                          (
                            <li key={idx}>
                              {exclusion?.exclusionShortDescription}
                            </li>
                          ):'',
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          {
            type: 'render',
            colSpan: repeatAdditionalDetails,
            component: () => {
              return (
                <Text type="title" className="font-bold">
                  <Text className="font-semibold ml-1 mt-3">
                    User Defined Exclusions
                  </Text>
                </Text>
              );
            },
          },
          ...(values?.userDefinedExclusions &&
          values?.userDefinedExclusions?.length > 0
            ? values?.userDefinedExclusions?.map((_, idx) => {
                return {
                  type: 'render',
                  colSpan: repeatAdditionalDetails,
                  component: () => {
                    return (
                      <Grid
                        className="mt-2"
                        flow="cols"
                        gap={2}
                        repeat={repeatAdditionalDetails}
                      >
                        <GridItem colSpan={repeatAdditionalDetails}>
                          <Text
                            className={
                              screenType
                                ?.toString()
                                ?.toLowerCase() === 'mobile'
                                ? 'w-full'
                                : 'flex flex-row space-x-5'
                            }
                          >
                            <Text>
                            <QuantaInput
                                rows={3}
                                name={`userDefinedExclusions[${idx}].exclusion`}
                                size={'full'}
                                disabled={
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                'pending uw approval'

                                ||
                                fireQuote?.status
                                        ?.toString()
                                  ?.toLowerCase() === 'quote saved'
                                }
                                className={
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'w-full'
                                    : 'w-96'
                                }
                                label={
                                  <Text type={'label'}>
                                    #{idx + 1}{' '}
                                    <Text severity={'error'}></Text>
                                  </Text>
                                }
                              />
                            </Text>
                            {values?.userDefinedExclusions &&
                            values?.userDefinedExclusions?.length >
                              1 ? (
                              <Text
                                severity={'info'}
                                className={'flex items-center'}
                              >
                                {screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile' &&
                                (!fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter')
                                      ) ? (
                                  <Button
                                    flat={true}
                                    className="w-full"
                                    type={'button'}
                                    onClick={(_) => {
                                      setFieldValue(
                                        `userDefinedExclusions`,
                                        [
                                          ...values.userDefinedExclusions.slice(
                                            0,
                                            idx,
                                          ),
                                          ...values.userDefinedExclusions.slice(
                                            idx + 1,
                                          ),
                                        ],
                                      );
                                    }}
                                  >
                                    Delete
                                  </Button>
                                ) : !fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter') 
                                      ? (
                                  <div className="flex flex-col justify-center items-center">
                                    <Button
                                      flat={true}
                                      className="w-28 h-10"
                                      type={'button'}
                                      size={'small'}
                                      onClick={(_) => {
                                        setFieldValue(
                                          `userDefinedExclusions`,
                                          [
                                            ...values.userDefinedExclusions.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values.userDefinedExclusions.slice(
                                              idx + 1,
                                            ),
                                          ],
                                        );
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                ) : null}
                              </Text>
                            ) : null}
                          </Text>
                        </GridItem>
                      </Grid>
                    );
                  },
                };
              })
            : []),
          !fireQuote?.status ||
          fireQuote?.status?.toString()?.toLowerCase() ===
            'quote draft' ||
          (fireQuote?.status?.toString()?.toLowerCase() ===
            'pending uw approval' &&
            role?.toString()?.toLowerCase() === 'underwriter')
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text>
                      <Button
                        flat={true}
                        size={'small'}
                        type={'button'}
                        disabled={fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'} 
                        className={
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'w-full h-10 mb-4'
                            : 'flex justify-end mr-64 w-28 h-10 mb-4'
                        }
                        onClick={(_) => {
                          setFieldValue('userDefinedExclusions', [
                            ...values?.userDefinedExclusions,
                            {
                              exclusion: '',
                            },
                          ]);
                        }}
                      >
                        Add
                      </Button>
                    </Text>
                  );
                },
              }
            : null,
        ]?.filter((d) => d),
      },
    ].filter((d) => d);

    const exclusionDataProps = {
      flow: 'cols',
      repeat: repeatAdditionalDetails,
      gapX: 6,
      gapY: 6,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    const conditionData = [
      {
        grid_data: [
          getDefaultConditions && getDefaultConditions?.length > 0
            ? {
                type: 'render',
                colSpan: repeatAdditionalDetails,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text className="font-semibold ml-1 mt-3">
                        Default Conditions
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultConditions?.map(
                          (condition, idx) => 
                          condition?.txtDefault?.toString() === 'Y' ?
                          (
                            <li key={idx}>
                              {condition?.conditionShortDescription}
                            </li>
                          ) :'',
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          {
            type: 'render',
            colSpan: repeatAdditionalDetails,
            component: () => {
              return (
                <Text type="title" className="font-bold">
                  <Text className="font-semibold ml-1 mt-3">
                    User Defined Conditions
                  </Text>
                </Text>
              );
            },
          },
          ...(values?.userDefinedConditions &&
          values?.userDefinedConditions?.length > 0
            ? values?.userDefinedConditions?.map((_, idx) => {
                return {
                  type: 'render',
                  colSpan: repeatAdditionalDetails,
                  component: () => {
                    return (
                      <Grid
                        className="mt-2"
                        flow="cols"
                        gap={2}
                        repeat={repeatAdditionalDetails}
                      >
                        <GridItem colSpan={repeatAdditionalDetails}>
                          <Text
                            className={
                              screenType
                                ?.toString()
                                ?.toLowerCase() === 'mobile'
                                ? 'w-full'
                                : 'flex flex-row space-x-5'
                            }
                          >
                            <Text>
                            <QuantaInput
                                rows={3}
                                name={`userDefinedConditions[${idx}].condition`}
                                size={'full'}
                                disabled={
                                    fireQuote?.status
                                      ?.toString()
                                      ?.toLowerCase() ===
                                'pending uw approval'

                                ||
                                fireQuote?.status
                                        ?.toString()
                                  ?.toLowerCase() === 'quote saved'
                                }
                                className={
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 'w-full'
                                    : 'w-96'
                                }
                                label={
                                  <Text type={'label'}>
                                    #{idx + 1}{' '}
                                    <Text severity={'error'}></Text>
                                  </Text>
                                }
                              />
                            </Text>
                            {values?.userDefinedConditions &&
                            values?.userDefinedConditions?.length >
                              1 ? (
                              <Text
                                severity={'info'}
                                className={'flex items-center'}
                              >
                                {screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile' &&
                                (!fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter')
                                      ) 
                                      ? (
                                  <Button
                                    flat={true}
                                    className="w-full"
                                    type={'button'}
                                    size={'small'}
                                    onClick={(_) => {
                                      setFieldValue(
                                        `userDefinedConditions`,
                                        [
                                          ...values.userDefinedConditions.slice(
                                            0,
                                            idx,
                                          ),
                                          ...values.userDefinedConditions.slice(
                                            idx + 1,
                                          ),
                                        ],
                                      );
                                    }}
                                  >
                                    Delete
                                  </Button>
                                ) : !fireQuote?.status ||
                                  fireQuote?.status
                                    ?.toString()
                                    ?.toLowerCase() ===
                                    'quote draft' 
                                  //   ||
                                  // (fireQuote?.status
                                  //   ?.toString()
                                  //   ?.toLowerCase() ===
                                  //   'pending uw approval' &&
                                  //   role
                                  //     ?.toString()
                                  //     ?.toLowerCase() ===
                                  //     'underwriter') 
                                      ? (
                                  <div className="flex flex-col justify-center items-center">
                                    <Button
                                      flat={true}
                                      className="w-28 h-10"
                                      type={'button'}
                                      size={'small'}
                                      onClick={(_) => {
                                        setFieldValue(
                                          `userDefinedConditions`,
                                          [
                                            ...values.userDefinedConditions.slice(
                                              0,
                                              idx,
                                            ),
                                            ...values.userDefinedConditions.slice(
                                              idx + 1,
                                            ),
                                          ],
                                        );
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </div>
                                ) : null}
                              </Text>
                            ) : null}
                          </Text>
                        </GridItem>
                      </Grid>
                    );
                  },
                };
              })
            : []),
          !fireQuote?.status ||
          fireQuote?.status?.toString()?.toLowerCase() ===
            'quote draft' ||
          (fireQuote?.status?.toString()?.toLowerCase() ===
            'pending uw approval' &&
            role?.toString()?.toLowerCase() === 'underwriter')
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text>
                      <Button
                        flat={true}
                        size={'small'}
                        type={'button'}
                        disabled={fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'} 
                        className={
                          screenType?.toString()?.toLowerCase() ===
                          'mobile'
                            ? 'w-full h-10 mb-4'
                            : 'flex justify-end mr-64 w-28 h-10 mb-4'
                        }
                        onClick={(_) => {
                          setFieldValue('userDefinedConditions', [
                            ...values?.userDefinedConditions,
                            {
                              condition: '',
                            },
                          ]);
                        }}
                      >
                        Add
                      </Button>
                    </Text>
                  );
                },
              }
            : null,
        ]?.filter((d) => d),
      },
    ].filter((d) => d);

    const conditionDataProps = {
      flow: 'cols',
      repeat: repeatAdditionalDetails,
      gapX: 6,
      gapY: 6,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    // const underwriterData = [
    //   {
    //     grid_data: [
    //       {
    //         type: 'render',
    //         colSpan: repeatAdditionalDetails,
    //         component: () => {
    //           return (
    //             <Grid
    //               className="mt-3 w-full"
    //               flow="cols"
    //               gap={2}
    //               repeat={repeatAdditionalDetails}
    //             >
    //               <GridItem
    //                 colSpan={repeatAdditionalDetails}
    //                 className={'w-full'}
    //               >
    //                 <Text
    //                   className={
    //                     screenType?.toString()?.toLowerCase() ===
    //                     'mobile'
    //                       ? 'w-full'
    //                       : 'flex flex-row w-full space-x-5'
    //                   }
    //                 >
    //                   <Text className={'w-full'}>
    //                     <QuantaTextArea
    //                       type={'textarea'}
    //                       name={`underwriterComment`}
    //                       size={'full'}
    //                       colSpan={repeatAdditionalDetails}
    //                       rows={2}
    //                       disabled={
    //                         fireQuote?.status
    //                           ?.toString()
    //                           ?.toLowerCase() ===
    //                           'underwriter rejected' ||
    //                         fireQuote?.status
    //                           ?.toString()
    //                           ?.toLowerCase() ===
    //                           'underwriter approved' ||
    //                         fireQuote?.status
    //                           ?.toString()
    //                           ?.toLowerCase() ===
    //                           'converted to proposal'
    //                       }
    //                       className={
    //                         screenType?.toString()?.toLowerCase() ===
    //                         'mobile'
    //                           ? 'w-full'
    //                           : 'w-full'
    //                       }
    //                       label={
    //                         <Text type={'label'}>
    //                           Comments{' '}
    //                           <Text severity={'error'}>*</Text>
    //                         </Text>
    //                       }
    //                     />
    //                   </Text>
    //                 </Text>
    //               </GridItem>
    //             </Grid>
    //           );
    //         },
    //       },
    //     ],
    //   },
    // ].filter((d) => d);

    // const underwriterDataProps = {
    //   flow: 'cols',
    //   repeat: repeatAdditionalDetails,
    //   gapX: 6,
    //   gapY: 6,
    //   spaceY: 2,
    //   size: 'full',
    //   titleSeverity: 'info',
    // };

    return (
      <>
        <QuantaForm className={'flex flex-col space-y-4'}>
          <CustomerSummary
            {...{
              changeDisabled: false,
              fireQuote,
              goToStep,
              loadingPremium: false,
              getDefaultClauses,
              getDefaultConditions,
              getDefaultExclusions,
              getDefaultWarranties,
              valuesAdditionalTabDetails: values,
              role,
            }}
          />
          <LocationCoverageDetails
            {...{
              fireQuote,
              goToStep,
              values,
              productName,
              role,
            }}
          />
          <Text type={'title'} severity={'info'} className={'mb-4'}>
            Additional Details
          </Text>
          {!isQuoteReadOnly && (
            <InputGridGroup
              {...{
                data: uploadDocumentsData,
                ...uploadDocumentsDataProps,
              }}
            />
          )}
          <Text severity={'info'} className={'text-lg pt-4'}>
            Clauses
          </Text>
          <Paper>
            <InputGridGroup
              {...{ data: clauseData, ...clauseDataProps }}
            />
          </Paper>
          <Text severity={'info'} className={'text-lg pt-4'}>
            Warranties
          </Text>
          <Paper>
            <InputGridGroup
              {...{ data: warrantyData, ...warrantyDataProps }}
            />
          </Paper>
          <Text severity={'info'} className={'text-lg pt-4'}>
            Exclusions
          </Text>
          <Paper>
            <InputGridGroup
              {...{ data: exclusionData, ...exclusionDataProps }}
            />
          </Paper>
          <Text severity={'info'} className={'text-lg pt-4'}>
            Conditions
          </Text>
          <Paper>
            <InputGridGroup
              {...{ data: conditionData, ...conditionDataProps }}
            />
          </Paper>
          {/* {fireQuote?.status?.toString()?.toLowerCase() ===
            'pending uw approval' &&
            role?.toString().toLowerCase() === 'underwriter' && (
              <>
                <Text severity={'info'} className={'text-lg pt-4'}>
                  Underwriter Comments
                </Text>
                <Paper>
                  <InputGridGroup
                    {...{
                      data: underwriterData,
                      ...underwriterDataProps,
                    }}
                  />
                </Paper>
              </>
            )} */}
          <Text
            className={`flex justify-end items-center ${
              screenType?.toString()?.toLowerCase() === 'mobile'
                ? 'flex-col space-y-4'
                : 'space-x-4'
            }`}
          >
            <Text
              className={`${
                screenType?.toString()?.toLowerCase() === 'mobile'
                  ? 'w-full'
                  : ''
              }`}
            >
              <Button
                type={'button'}
                size={'small'}
                className={`h-10 ${
                  screenType?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : 'w-44'
                }`}
                iconPost={
                  <FontAwesomeIcon icon={faChevronCircleRight} />
                }
                disabled={
                  validate(values) &&
                  Object?.entries(validate(values))?.length > 0
                    ? true
                    : false
                }
                onClick={(_) => {
                  if (
                    fireQuote?.status?.toString()?.toLowerCase() ===
                    'quote draft' || fireQuote?.quoteNumber === ''
                  ) {
                    setSubmitQuoteModalDisplay(true);
                  } else if (
                    role?.toString()?.toLowerCase() ===
                      'underwriter' &&
                    fireQuote?.status?.toString()?.toLowerCase() ===
                      'pending uw approval'
                  ) {
                    goToStep(3);
                    // updateFireQuote({
                    //   tabDetails: {
                    //     ...fireQuote?.tabDetails,
                    //     additionalTabDetails: {
                    //       // warranties: {
                    //       //   defaultWarranties:
                    //       //     getDefaultWarranties?.map(
                    //       //       (warranty) =>
                    //       //         warranty?.warrantyShortDescription,
                    //       //     ),
                    //       //   userDefinedWarranties:
                    //       //     values?.userDefinedWarranties
                    //       //       ?.filter((udw) => udw?.warranty)
                    //       //       ?.map((udw) => {
                    //       //         return udw?.warranty;
                    //       //       }),
                    //       // },
                    //       // exclusions: {
                    //       //   defaultExclusions:
                    //       //     getDefaultExclusions?.map(
                    //       //       (exclusion) =>
                    //       //         exclusion?.exclusionShortDescription,
                    //       //     ),
                    //       //   userDefinedExclusions:
                    //       //     values?.userDefinedExclusions
                    //       //       ?.filter((ude) => ude?.exclusion)
                    //       //       ?.map((ude) => {
                    //       //         return ude?.exclusion;
                    //       //       }),
                    //       // },
                    //       // clauses: {
                    //       //   defaultClauses: getDefaultClauses?.map(
                    //       //     (clause) => clause?.clauseDescription,
                    //       //   ),
                    //       //   userDefinedClauses:
                    //       //     values?.userDefinedClauses
                    //       //       ?.filter((udc) => udc?.clause)
                    //       //       ?.map((udc) => {
                    //       //         return udc?.clause;
                    //       //       }),
                    //       // },
                    //       // conditions: {
                    //       //   defaultConditions:
                    //       //     getDefaultConditions?.map(
                    //       //       (condition) =>
                    //       //         condition?.conditionShortDescription,
                    //       //     ),
                    //       //   userDefinedConditions:
                    //       //     values?.userDefinedConditions
                    //       //       ?.filter((udc) => udc?.condition)
                    //       //       ?.map((udc) => {
                    //       //         return udc?.condition;
                    //       //       }),
                    //       // },
                    //       underwriterComment:
                    //         values?.underwriterComment
                    //           ? values?.underwriterComment
                    //           : '',
                    //     },
                    //   },
                    // });
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  } else {
                    goToStep(3);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                {fireQuote?.status
                  ?.toString()
                  ?.trim()
                  ?.toLowerCase() === 'pending uw approval' &&
                role?.toString()?.toLowerCase() === 'underwriter' &&
                fireQuote?.tabDetails?.customerTabDetails
                  ?.customerDetails
                  ? 'Proceed'
                  : isQuoteReadOnly
                  ? 'View Finalised Quote'
                  : 'Submit Quote'}
              </Button>
            </Text>
          </Text>
        </QuantaForm>
        <ModalSubmitQuote
          submitQuoteModalDisplay={submitQuoteModalDisplay}
          onSubmitQuote={(_) => {
            setModalSaveQuoteDisplay(true);
            uploadDocRef.current = [];
          }}
          onClose={(_) => {
            setSubmitQuoteModalDisplay(false);
            uploadDocRef.current = [];
            document.body.classList.remove('overflow-y-hidden');
          }}
        />
        <ModalSaveQuote
          modalSaveQuoteDisplay={modalSaveQuoteDisplay}
          onClose={(_) => {
            setModalSaveQuoteDisplay(false);
            document.body.classList.remove('overflow-y-hidden');
          }}
          values={values}
          getDefaultClauses={getDefaultClauses}
          getDefaultConditions={getDefaultConditions}
          getDefaultExclusions={getDefaultExclusions}
          getDefaultWarranties={getDefaultWarranties}
          fireQuote={fireQuote}
          setAlerts={setParentAlerts}
          setButtonLabelCustomerTab={setButtonLabelCustomerTab}
          lobCode={lobCode}
          productCode={productCode}
          selectedIntermediary={selectedIntermediary}
          goToStep={goToStep}
        />
        <NotificationList
          {...{
            items: alerts,
            resetAlerts: (idx) => {
              const alertToBeRemovedPos = alerts.findIndex(
                (a) => a.id === idx,
              );
              setAlerts([
                ...alerts.slice(0, alertToBeRemovedPos),
                ...alerts.slice(
                  alertToBeRemovedPos + 1,
                  alerts.length,
                ),
              ]);
              uploadDocRef.current = [];
            },
          }}
        />
      </>
    );
  };
  return (
    <QuantaFormik
      innerRef={additionalDetailsFormRef}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
    >
      <AdditionalDetailsForm validate={validate} />
    </QuantaFormik>
  );
}
